import { REMOVE_ERROR } from './errors-actions';

export const INVALID_REQUEST_MADE = 'INVALID_REQUEST_MADE';

function invalidRequestMade() {
    return (dispatch, getState) => {
        const { errors } = getState();
        let payload = null;
        if (errors.length > 0) {
            payload = errors[errors.length - 1];
        }

        dispatch({
            type: INVALID_REQUEST_MADE,
            payload
        });
        dispatch({ type: REMOVE_ERROR });
    };
}

export default {
    invalidRequestMade
};



// WEBPACK FOOTER //
// ./containers/app/errors/invalid-request-actions.js